<div class="main-dialog-right" #mainDialogRight>
  <mat-toolbar class="header-section-list">
    <mat-toolbar-row >
      @if (loaded && appelASupport != null && appelASupport.clientReference != null && appelASupport.lastWriteDateTimeUtc != null) {
        <mat-list class="header-section-mat-list">
          <mat-list-item>
            <h4 mat-line>
              Appel à support {{appelASupport.clientReference}} du
              {{appelASupport.lastWriteDateTimeUtc | date:'dd MMMM yyyy'}}
            </h4>
          </mat-list-item>
        </mat-list>
      }
      <div class="right-header-icon">
        <a (click)="closeSidenav()" class="download">
          <mat-icon matIconButton>highlight_off</mat-icon>
        </a>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  @if (loaded && appelASupport != null) {
  <mat-tab-group mat-stretch-tabs color="accent">
    <mat-tab>
      <div class="main-content">
        <ng-template mat-tab-label>
          <mat-icon>description</mat-icon>
          Détails
        </ng-template>
      </div>
      <div class="main-content">
        <div class="couvertureTitle">
          <h4 mat-line>Sujet</h4>
          <div class="subject">{{appelASupport.subject}}</div>
        </div>
      </div>
      <div class="main-content">
        <div class="couvertureTitle">
          <h4 mat-line>Etat d'avancement</h4>
        </div>
      </div>
      <div class="main-content">
        <div style="margin : 28px 0 28px 0 ">
          <ul class="progress-indicator">
            <li
              [class.completed]="appelASupport.creationDateTimeUtc != null &&  appelASupport.creationDateTimeUtc != '' ">
              <span class="bubble">
              </span>Création<br />
              @if (appelASupport.creationDateTimeUtc != null && appelASupport.creationDateTimeUtc != '') {
                {{appelASupport.creationDateTimeUtc | date}}
              }
            </li>
            <li
              [class.completed]="appelASupport.receptionDateTimeUtc != null && appelASupport.receptionDateTimeUtc != '' ">
              <span class="bubble">
              </span>Réception<br />
              @if (appelASupport.receptionDateTimeUtc != null && appelASupport.receptionDateTimeUtc != '') {
                {{appelASupport.receptionDateTimeUtc | date}}
              }
            </li>
            <li [class.completed]="appelASupport.startDateTimeUtc != null && appelASupport.startDateTimeUtc != '' ">
              <span class="bubble">
              </span>Traitement<br />
              @if (appelASupport.startDateTimeUtc != null && appelASupport.startDateTimeUtc != '') {
                {{appelASupport.startDateTimeUtc | date}}
              }
            </li>
            <li
              [class.completed]="appelASupport.completeDateTimeUtc != null && appelASupport.completeDateTimeUtc != '' ">
              <span class="bubble">
              </span>Validation<br />
              @if (appelASupport.completeDateTimeUtc != null && appelASupport.completeDateTimeUtc != '') {
                {{appelASupport.closeDateTimeUtc | date}}
              }
            </li>
            <li
              [class.completed]="appelASupport.completeDateTimeUtc != null &&  appelASupport.completeDateTimeUtc != '' ">
              <span class="bubble">
              </span>Cloture<br />
              @if (appelASupport.closeDateTimeUtc != null && appelASupport.closeDateTimeUtc != '') {
                {{appelASupport.closeDateTimeUtc | date}} <br />
              }
              @if (appelASupport.closeDateTimeUtc == null || appelASupport.closeDateTimeUtc == '') {
                <button matButton="filled" class="button-close-as" (click)="confirmTicket(appelASupport)">
                  Clôturer</button>
              }
            </li>
          </ul>
        </div>
      </div>
      <div class="main-content">
        <div class="couvertureTitle">
          <h4 mat-line>Conversation </h4>
        </div>
      </div>
      <div class="main-content">
        <div class="chat">
          @for (message of appelASupport.conversation; track $index; let i = $index) {
            @if (message.direction != 'I') {
            <div class="yours messages">
              <div class="msg-meta-data">
                @if (getDelegatorDisplayName(message) != 'inconnu' && getAuthorDisplayName(message) != 'inconnu') {
                  Message émis par {{getDelegatorDisplayName(message)}} au nom de
                  {{getAuthorDisplayName(message)}}
                } @else {
                  Message émis par
                  @if (getDelegatorDisplayName(message) != 'inconnu') {
                    {{getDelegatorDisplayName(message)}}
                  }
                  @if (getAuthorDisplayName(message) != 'inconnu') {
                    {{getAuthorDisplayName(message)}}
                  }
                }
                @if (message.creationDateTimeUtc != null && message.creationDateTimeUtc != '') {
                  le
                  {{message.creationDateTimeUtc | date:'dd/MM/yyyy à HH:mm' }}
                }
              </div>
              <div class="message">{{message.message}}</div>
            </div>
            } @else {
              <div class="mine messages">
                <div class="msg-meta-data">
                  @if (getDelegatorDisplayName(message) != 'inconnu' && getAuthorDisplayName(message) != 'inconnu') {
                    Message émis par {{getDelegatorDisplayName(message)}} au nom de
                    {{getAuthorDisplayName(message)}}
                  } @else {
                    Message émis par
                    @if (getDelegatorDisplayName(message) != 'inconnu') {
                      {{getDelegatorDisplayName(message)}}
                    }
                    @if (getAuthorDisplayName(message) != 'inconnu') {
                      {{getAuthorDisplayName(message)}}
                    }
                  }
                  @if (message.creationDateTimeUtc != null && message.creationDateTimeUtc != '') {
                    le
                    {{message.creationDateTimeUtc | date:'dd/MM/yyyy à HH:mm' }}
                  }
                </div>
                @if (i == 0 && message.message == '') {
                  <div class="message">{{appelASupport.subject}}</div>
                } @else {
                  <div class="message">{{message.message}}</div>
                }
              </div>
            }
          }
        </div>
      </div>

      @if (appelASupport != null && appelASupport.closeDateTimeUtc != '') {
      <div class="main-content">
        <div class="couvertureTitle">
          <form [formGroup]=formGroupArray[0] class="inline-flex">
            <h4 mat-line class="h4-inline">Ajouter une réponse</h4>

            <span class="in-name-of">au nom de :</span>
            @if (userListState == 1) {
            <span class="zone-saisie-user">
              <mat-form-field class="singleTextField mat-select-width">
                <!-- affichage en forcé-->
                <mat-label>Déclarant</mat-label>
                <mat-select formControlName="nom" class="mat-select-from">
                  <mat-option value=""></mat-option>
                  @for (user of userList; track user.idUnique) {
                  <mat-option [value]="user.idUnique" required>
                    {{user.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </span>
            } @else {
              @if (userListState == 0) {
                <div class="loading">
                  <mat-spinner></mat-spinner>
                </div>
              } @else {
                <!-- <mat-form-field class="singleTextField">
                  <input matInput placeholder="Nom du déclarant" formControlName="nom">
                </mat-form-field> -->
              }
            }

          </form>
        </div>
      </div>
      <div class="main-content reponse-main">
        <div class="div-saisie-reponse">
          <form [formGroup]=formGroupArray[0]>
            <mat-form-field class="textAreaField mat-text-area">
              <textarea matInput placeholder="Votre réponse" required MatFormFieldAppearance="fill"
                class="textAreaField" formControlName="message"></textarea>
            </mat-form-field>
          </form>
          <div class="btn-valider-reponse">
            <button matButton="filled" (click)="addMessage()" class="secondary">Répondre</button>
          </div>

        </div>
      </div>
      }
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>folder</mat-icon>
        Documents
      </ng-template>
      <div>
        <mat-list>
          <mat-list-item class="couvertureTitle">
            <h4 mat-line>Documents</h4>
          </mat-list-item>
        </mat-list>
        <div style="padding-left : 20px">
          @for (document of documents; track $index; let i = $index) {
          <mat-list style="display: inline;">
            <a href="{{encodeURI(document)}}" class="unset-a-link">
              <mat-list-item class="half-width download" [class.align-right]="i%2 != 0" [class.align-left]="i%2 == 0">
                @if (fileIsNew(document)) {
                <mat-icon matBadge="N" matBadgeColor="warn" matListItemIcon style="margin-top:28px !important">
                  @switch (iconParse(document.fileName)) {
                  @case ('pdf') {
                    <i class="far fa-file-pdf"></i>
                  }
                  @case ('doc') {
                    <i class="far fa-file-word"></i>
                  }
                  @case ('docx') {
                    <i class="far fa-file-word"></i>
                  }
                  @case ('png') {
                    image
                  }
                  @case ('jpeg') {
                    image
                  }
                  @case ('jpg') {
                    image
                  }
                  @case ('bmp') {
                    image
                  }
                  @case ('mpeg') {
                    local_movies
                  }
                  @case ('mpeg4') {
                    local_movies
                  }
                  @case ('mp4') {
                    local_movies
                  }
                  @case ('bmp') {
                    local_movies
                  }
                  @case ('avi') {
                    local_movies
                  }
                  @case ('xls') {
                    <i class="far fa-file-excel"></i>
                  }
                  @case ('xlsx') {
                    <i class="far fa-file-excel"></i>
                  }
                  @default {
                    attach_file
                  }
                  }
                </mat-icon>
                } @else {
                  <mat-icon matListItemIcon style="margin-top:28px !important">
                    @switch (iconParse(document.fileName)) {
                    @case ('pdf') {
                      <i class="far fa-file-pdf"></i>
                    }
                    @case ('doc') {
                      <i class="far fa-file-word"></i>
                    }
                    @case ('docx') {
                      <i class="far fa-file-word"></i>
                    }
                    @case ('png') {
                      image
                    }
                    @case ('jpeg') {
                      image
                    }
                    @case ('jpg') {
                      image
                    }
                    @case ('bmp') {
                      image
                    }
                    @case ('mpeg') {
                      local_movies
                    }
                    @case ('mpeg4') {
                      local_movies
                    }
                    @case ('mp4') {
                      local_movies
                    }
                    @case ('bmp') {
                      local_movies
                    }
                    @case ('avi') {
                      local_movies
                    }
                    @case ('xls') {
                      <i class="far fa-file-excel"></i>
                    }
                    @case ('xlsx') {
                      <i class="far fa-file-excel"></i>
                    }
                    @default {
                      attach_file
                    }
                    }
                  </mat-icon>
                }
                <div matListItemTitle>{{document.fileName}}</div>
                <div matListItemLine class="italic-text">taille : {{getReadableSize(document.fileSize,
                  true)}}</div>
                <!-- </ng-template> -->
              </mat-list-item>
            </a>
          </mat-list>
          }
          @if (documents.length == 0) {
          <mat-list>
            <mat-list-item><span class="warn-message">Il n'y a aucun document associé à cet appel à
                support</span></mat-list-item>
          </mat-list>
          }
        </div>
        @if (appelASupport != null && appelASupport.closeDateTimeUtc != '') {
        <mat-list>
          <mat-list-item class="couvertureTitle">
            <h4 mat-line>Ajout de documents </h4>
          </mat-list-item>
        </mat-list>
        <app-envoi-fichier
          [idDecalrationappelASupport]=appelASupport.ticketUniqueId (filesSended)="updateFilesSended($event)">
        </app-envoi-fichier>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
  } @else {
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>